// extracted by mini-css-extract-plugin
module.exports = {"root":"Slider_root__1dVlS","wrapper":"Slider_wrapper__179Bg"};